function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingNow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/allplaceapplication/download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hf1a916n8a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/allplaceapplication/download (clip mask)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h16v16H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/allplaceapplication/download (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/allplaceapplication/download",
    style: {
      clipPath: "url(#hf1a916n8a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/allplaceapplication/download (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/allplaceapplication/download (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#hf1a916n8a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.24 4.3 11.037.238a.625.625 0 0 0-.49-.238H9.281a.157.157 0 0 0-.123.254l2.818 3.574H.156A.157.157 0 0 0 0 3.984v1.172a.157.157 0 0 0 .156.156h13.592A.625.625 0 0 0 14.24 4.3z",
    transform: "translate(.813 3.344)",
    style: {
      fill: "current"
    },
    "data-name": "icon/outlined/allplaceapplication/calendar"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingNow);
export default __webpack_public_path__ + "static/media/meetingNow.55e0a2eea3eb70199f3faca39294351e.svg";
export { ForwardRef as ReactComponent };